'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _helpers = require('../common/helpers');

var _constants = require('../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserService = function UserService() {
    var _this = this;

    _classCallCheck(this, UserService);

    this.login = function (credentials) {
        return new Promise(function (resolve, reject) {
            var loginUrl = "/v1/user/login";
            (0, _helpers.ajax)(loginUrl, 'POST', credentials).then(function (user) {
                if (user.status === Constants.SUCCESS) {
                    localStorage.setItem(Constants.NS_USER, JSON.stringify(user.data));
                }
                resolve(user);
            }).catch(function (err) {
                return reject(err);
            });
        });
    };

    this.log = function (activity) {
        _this.get().then(function (user) {
            var activityUrl = '/v1/activity/user/' + user.session_id + '/log';
            switch (activity.type) {
                case Constants.ACTIVITY_PAGE_VISIT:
                    var activityData = {
                        "activity": activity.type,
                        "remarks": activity.type,
                        "activity_on": Date.now(),
                        "url": window.location.pathname,
                        "referrer_url": document.referrer,
                        "page": activity.page
                    };
                    if (activity.data) {
                        activityData.custom_data = activity.data;
                    }
                    return (0, _helpers.ajax)(activityUrl, 'POST', activityData);
            }
        });
    };

    this.getUser = function () {
        return JSON.parse(localStorage.getItem(Constants.NS_USER));
    };

    this.get = function () {
        return new Promise(function (resolve, reject) {
            var user = JSON.parse(localStorage.getItem(Constants.NS_USER));
            resolve(user);
            // if (user) {
            //     resolve(user)
            // } else {
            //     this.create({userType: Constants.USER_TYPE_GUEST})
            //         .then(user => {
            //             // console.log(user)
            //             localStorage.setItem(Constants.NS_USER, JSON.stringify(user))
            //             resolve(user)
            //         })
            //         .catch(err => reject(err))
            // } 
        });
    };

    this.create = function (_ref) {
        var _ref$userType = _ref.userType,
            userType = _ref$userType === undefined ? "guest" : _ref$userType;

        return new Promise(function (resolve, reject) {
            var addUserUrl = "/v1/user/add";
            var reqParams = {
                type: userType
            };
            (0, _helpers.ajax)(addUserUrl, 'POST', reqParams).then(function (res) {
                return resolve(res.data);
            }).catch(function (err) {
                return reject(err);
            });
        });
    };

    this.addUser = function (userData) {
        localStorage.setItem(Constants.NS_USER, JSON.stringify(userData));
    };

    this.getAccessToken = function () {
        var user = JSON.parse(localStorage.getItem(Constants.NS_USER));

        if (user && user.token) {
            return user.token;
        } else {
            console.warn('No token found');
            return null;
        }
    };

    this.getMqttBasename = function () {
        var user = JSON.parse(localStorage.getItem(Constants.NS_USER));

        if (user && user.mqtt && user.mqtt.base_name) {
            return user.mqtt.base_name;
        } else {
            console.warn('No Mqtt Basename found');
            return null;
        }
    };

    this.getSessionId = function () {
        var user = JSON.parse(localStorage.getItem(Constants.NS_USER));

        if (user && user.session_id) {
            return user.session_id;
        } else {
            console.warn('No session id found');
            return null;
        }
    };
};

exports.default = new UserService();


// WEBPACK FOOTER //
// ../chat/lib/services/userservice.js